import * as React from "react";
const SvgExternalLinkIcon = props => <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m5 3c-1.108 0-2 0.892-2 2v10c0 1.108 0.892 2 2 2h10c1.108 0 2-0.892 2-2v-4a1 1 0 0 0-1-1 1 1 0 0 0-1 1v4h-10v-10h4a1 1 0 0 0 1-1 1 1 0 0 0-1-1h-4z" style={{
    fill: "currentcolor"
  }} /><path d="m16 4-5 5m1-5h4v4" style={{
    fill: "none",
    paintOrder: "markers fill stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    stroke: "currentcolor"
  }} /></svg>;
export default SvgExternalLinkIcon;